// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/MoscowSans/MoscowSans_Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "MoscowSans";
  src: local("MoscowSans"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
}

body {
  font-family: "MoscowSans", Arial, sans-serif;
  background: #f5f6f7 !important;
}
body * {
  font-family: "MoscowSans", Arial, sans-serif;
}

.special-color-1 .limited .separator {
  background-color: #000 !important;
}

.modals {
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB;8DACqE;EACrE,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf","sourcesContent":["@font-face {\r\n  font-family: \"MoscowSans\";\r\n  src: local(\"MoscowSans\"),\r\n    url(\"./fonts/MoscowSans/MoscowSans_Regular.ttf\") format(\"truetype\");\r\n  font-weight: normal;\r\n}\r\n\r\nbody {\r\n  font-family: \"MoscowSans\", Arial, sans-serif;\r\n  background: #f5f6f7 !important;\r\n}\r\nbody * {\r\n  font-family: \"MoscowSans\", Arial, sans-serif;\r\n}\r\n\r\n.special-color-1 .limited .separator {\r\n  background-color: #000 !important;\r\n}\r\n\r\n.modals {\r\n  z-index: 1000;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
